module.exports = __webpack_public_path__ + "assets/img/5_1162.d555ef29.jpg";